// This file is not used for production, the config is loaded via a config service from assets/config/config.json and replaced during deployment
// see libs/api/shared/src/lib/config/config-asset-loader.service.ts
//add the config in icullen-front.configmap.json in the k8s deployment
export const environment = {
  production: true,
  apiBaseUrl: 'https://api.cullen-international.com/v1/',
  ssoIssuer: 'https://auth.cullen-international.com/realms/cullen',
  deployBaseHref: '/client',
  recaptchaSiteKey: '6Lftqc8eAAAAAJlUKpY2F3XQeZUjjzsV6_sLUD2T',
  POSTHOG_KEY: 'phc_aNOovPoGHhD8AKvYZzQxbL2o73JeXlJ0A2klP3RzCBe',
  POSTHOG_HOST: 'https://eu.i.posthog.com',
  deliveryServiceBaseUrl: 'https://delivery.fn.cullen-international.com/',
};
